import React, { useRef } from "react";
import { Link } from "react-router-dom";
import { ChevronLeft, ChevronRight } from "lucide-react";

export default function TopTenRow({ items }) {
  const ref = useRef(null);
  if (!items || items.length === 0) return null;
  const scroll = (dir) => ref.current?.scrollBy({ left: 700 * dir, behavior: "smooth" });
  return (
    <section className="relative mb-12 group/row" data-testid="row-top-10">
      <div className="flex items-center justify-between mb-4 px-6 lg:px-12">
        <h2 className="text-xl md:text-2xl font-semibold tracking-tight">
          <span className="text-grad-red">Top 10</span> · Trending this week
        </h2>
        <span className="text-xs uppercase tracking-widest text-gray-500">Ranked by views</span>
      </div>
      <div className="relative">
        <button onClick={() => scroll(-1)} className="absolute left-0 top-0 bottom-0 z-30 w-12 lg:w-20 bg-gradient-to-r from-[#0A0A0A] to-transparent opacity-0 group-hover/row:opacity-100 transition-opacity flex items-center justify-center text-gray-400 hover:text-white">
          <ChevronLeft className="w-8 h-8" />
        </button>
        <div ref={ref} className="flex gap-2 overflow-x-auto scrollbar-hide snap-x snap-mandatory px-6 lg:px-12 pb-6">
          {items.map((v) => (
            <Link
              key={`top10-${v.id}`}
              to={`/title/${v.id}`}
              data-testid={`top10-${v.rank}`}
              className="relative flex-shrink-0 snap-start group flex items-end"
            >
              <span
                className="text-[160px] md:text-[200px] font-black leading-none tracking-tighter pointer-events-none select-none"
                style={{
                  WebkitTextStroke: "4px #E50914",
                  color: "transparent",
                  textShadow: "12px 12px 0 rgba(229,9,20,0.15)",
                  fontFamily: "Outfit, sans-serif",
                  marginRight: "-30px",
                  zIndex: 1,
                }}
              >
                {v.rank}
              </span>
              <div className="relative w-[140px] h-[200px] md:w-[170px] md:h-[240px] rounded-md overflow-hidden bg-[#121212] transition-transform duration-300 group-hover:scale-105 shadow-2xl z-10">
                <img src={v.poster} alt={v.title} className="w-full h-full object-cover" loading="lazy" />
                <div className="absolute inset-0 bg-gradient-to-t from-black via-transparent to-transparent" />
                <div className="absolute bottom-2 left-2 right-2">
                  <h4 className="text-white text-xs font-semibold line-clamp-2">{v.title}</h4>
                </div>
              </div>
            </Link>
          ))}
        </div>
        <button onClick={() => scroll(1)} className="absolute right-0 top-0 bottom-0 z-30 w-12 lg:w-20 bg-gradient-to-l from-[#0A0A0A] to-transparent opacity-0 group-hover/row:opacity-100 transition-opacity flex items-center justify-center text-gray-400 hover:text-white">
          <ChevronRight className="w-8 h-8" />
        </button>
      </div>
    </section>
  );
}
